import { type ReactNode } from 'react'
import Header from './Header'
import Footer from './Footer'

interface PublicShellProps {
  children: ReactNode
  hideFooter?: boolean
}

// 마케팅/공개 페이지 레이아웃 — 헤더 + 콘텐츠 + 푸터.
// 루트에 `public-shell` 클래스 — globals.css 에서 한국어 어절 단위 줄바꿈 + 헤드라인 balance wrap.
export default function PublicShell({ children, hideFooter = false }: PublicShellProps) {
  return (
    <div className="public-shell min-h-screen flex flex-col bg-surface-deep">
      <Header />
      <main className="flex-1 pt-16">
        {children}
      </main>
      {!hideFooter && <Footer />}
    </div>
  )
}
